<template>
    <div class="card card-with-shadow border-0 mt-3">
        <div class="card-header bg-transparent p-primary">
            <h5 class="card-title text-capitalize mb-0">{{ $t('upcomming_celebration') }}</h5>
        </div>
        <app-overlay-loader v-if="preloader" />
        <div class="card-body" v-else>
            <div v-if="celebration.birthday.length">
                <div v-for="emp in celebration.birthday" :key="emp.id"
                    class="d-flex align-items-center justify-content-between mb-3 p-2 border-bottom">
                    <!-- Avatar + Info -->
                    <div class="d-flex align-items-center">
                        <app-avatar :title="emp.first_name" avatar-class="avatars-w-50 mr-3"
                            :img="emp?.profile_picture?.full_url" alt-text="image" />

                        <div>
                            <div class="font-weight-bold">
                                {{ emp.first_name }} {{ emp.last_name }}
                            </div>
                            <small class="text-muted">
                                {{ formatDate(emp.profile?.date_of_birth) }}
                            </small>
                        </div>
                    </div>

                    <!-- Status Dot -->
                    <div>
                        <i class="fas fa-circle" :class="{
                            'text-success blink-dot': emp.birthday_status === 'T',
                            'text-warning': emp.birthday_status === 'U',
                            'text-secondary': emp.birthday_status === 'P'
                        }"></i>
                    </div>

                </div>
            </div>

            <div v-else class="text-center text-muted py-3">
                No birthdays this month
            </div>



        </div>
    </div>
</template>

<script>
import { axiosGet } from "../../../../../common/Helper/AxiosHelper";
import { APP_DASHBOARD } from "../../../../Config/ApiUrl";

export default {
    name: "UpcommingCelebration",
    data() {
        return {
            preloader: false,
            celebration: {},
        }
    },
    created() {
        this.getUpcommingEvent();
    },
    mounted() {
        this.$hub.$on('reload-dashboard', () => this.getUpcommingEvent())
    },
    methods: {
        getUpcommingEvent() {
            this.preloader = true;
            axiosGet(`${APP_DASHBOARD}/employee/upcomming-celebration`).then(({ data }) => {
                this.celebration = data;
            }).finally(() => {
                this.preloader = false;
            })
        },
        formatDate(date) {
            if (!date) return "";
            return new Date(date).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short"
            });
        }
    }
}
</script>

<style scoped>
.blink-dot {
    font-size: 10px;
    animation: blink 1s infinite;
}

@keyframes blink {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.2;
    }

    100% {
        opacity: 1;
    }
}
</style>